module.exports = __webpack_public_path__ + "img/组 1122@2x.8d75216c.png";